module.exports = __webpack_public_path__ + "static/coffee-1d11c622129d65fd50a61c29c7329952.svg";